import React from 'react';
import { PostHogProvider } from 'posthog-js/react';
import { AppProvider } from './contexts/AppContext';
import { AuthProvider } from './contexts/AuthContext';
import { SchoolProvider } from './contexts/SchoolContext';
import { ToastProvider } from './contexts/ToastContext';
import { DataProvider } from './contexts/DataContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AppRouter } from './AppRouter';
import { ToastContainer } from './components/shared/ToastContainer';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const posthogHost = (import.meta.env.VITE_POSTHOG_HOST as string) || 'https://us.posthog.com';

export default function App() {
  return (
    <PostHogProvider
      apiKey={posthogKey ?? ''}
      options={{
        api_host: posthogHost,
        loaded: (posthog) => {
          if (import.meta.env.DEV) posthog.debug();
        },
      }}
    >
      <ThemeProvider>
        <AuthProvider>
          <ToastProvider>
            <AppProvider>
              <DataProvider>
                <SchoolProvider>
                  <AppRouter />
                  <ToastContainer />
                </SchoolProvider>
              </DataProvider>
            </AppProvider>
          </ToastProvider>
        </AuthProvider>
      </ThemeProvider>
    </PostHogProvider>
  );
}
